import { render, staticRenderFns } from "./MapV2.vue?vue&type=template&id=2b82a335&"
import script from "./MapV2.vue?vue&type=script&lang=js&"
export * from "./MapV2.vue?vue&type=script&lang=js&"
import style0 from "./MapV2.vue?vue&type=style&index=0&id=2b82a335&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports